export default __webpack_public_path__ + "static/media/users.dfa98348.svg";